import {website} from '@/config.js'
//基本配置
export const config = {
  width: 1920,
  height: 1080,
  query: "function(){\n    return window.$glob.params || {}\n}",
  header: "function(){\n    return window.$glob.params || {}\n}",
  screen: 'x',
  mark: {
    show: false,
    text: '',
    fontSize: 20,
    color: 'rgba(100,100,100,0.2)',
    degree: -20
  },
  scale: 1,
  backgroundImage: `/img/bg/bg.png`,
  url: '',
  gradeShow: false,
  gradeLen: 30,
};
// 颜色的配置
export const colorOption = {
  size: 'small',
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  dialogWidth: '30%',
  column: [{
    label: '颜色1',
    prop: 'color1',
    type: 'color',
    align: 'center'
  }, {
    label: '渐变色',
    prop: 'color2',
    type: 'color',
    align: 'center'
  }, {
    label: '位置',
    prop: 'postion',
    type: 'number',
    align: 'center',
    max: 100
  }]
}
// 颜色的配置
export const singleColorOption = {
  size: 'small',
  menuWidth: 100,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  height: 125,
  dialogWidth: '30%',
  column: [{
    label: '基础',
    prop: 'color1',
    type: 'color',
    width: 55,
    align: 'center',
  }, {
    label: '渐变',
    prop: 'color2',
    type: 'color',
    width: 55,
    align: 'center',
  }, {
    label: '位置',
    prop: 'position',
    type: 'number',
    max: 100,
    width: 55,
    align: 'center',
  }]
}
export const singleColorPickerOption = {
  submitBtn: false,
  emptyBtn: false,
  size: 'small',
  column: [
    {
      label: '',
      prop: 'color',
      type: 'color',
      span: 28,
      labelWidth: 0,
    }
  ]
}
// 表格的列配置
export const tableOption = {
  menuWidth: 150,
  refreshBtn: false,
  columnBtn: false,
  labelWidth: 100,
  column: [{
    label: '名称',
    prop: 'label',
  }, {
    label: 'key值',
    prop: 'prop',
  }, {
    label: '宽度',
    prop: 'width',
    hide: true,
  }, {
    label: '状态',
    prop: 'hide',
    type: 'switch',
    hide: true,
    value: false,
    dicData: [{
      label: '隐藏',
      value: true
    }, {
      label: '显示',
      value: false
    },]
  }, {
    label: '格式化',
    prop: 'formatter',
    span: 24,
    hide: true,
  }]
}
//一些字典的配置
export const dicOption = {
  line: [{label: '线条', value: 'line'}, {label: '圆环', value: 'circle'}],
  fontWeight: [{label: '默认', value: 'normal'}, {label: '粗体', value: 'bold'}, {
    label: '加粗',
    value: 'bolder'
  }, {label: '细体', value: 'lighter'}],
  border: [{label: '无边框', value: ''}, {label: '内置图片', value: 'img'}, {label: '内置边框', value: 'border'}],
  textAlign: [{label: '居中', value: 'center'}, {label: '左对齐', value: 'left'}, {label: '右对齐', value: 'right'}],
  textWrap: [{label: '截断', value: 'truncate'}, {label: '换行', value: 'wrap'}],
  dataType: [{label: '静态数据', value: 0}, {label: 'API接口数据', value: 1}, {
    label: 'SQL数据库数据',
    value: 2
  }, {label: 'WebScoket', value: 3}, {label: 'Record数据集', value: 4}, {
    label: 'Public共用数据',
    value: 5
  }, {label: 'MQTT数据', value: 6}],
  orientList: [{label: '竖排', value: 'vertical'}, {label: '横排', value: 'horizontal'}],
  dataMethod: [{label: 'GET', value: 'get'}, {label: 'DELETE', value: 'delete'}, {
    label: 'POST',
    value: 'post'
  }, {label: 'PUT', value: 'put'}],
  eventList: ['vue', 'common', 'datav', 'bar', 'horizontalBar', 'periodBar', 'helmetBar', 'line', 'flop', 'funnel', 'gauge', 'map', 'map3D', 'worldMap', 'newMap3D', 'pie', 'pieCircle', 'pieCircleIndex', 'radar', 'text', 'tabs', 'rectangle'],
  dataList: ['data', 'vue', 'common', 'datav', 'text', 'wordcloud', 'tabs', 'map', 'map3D', 'newMap3D', 'worldMap', 'video', 'clapper', 'pie', 'pieCircle', 'pieCircleIndex', 'pictorialbar', 'iframe', 'swiper', 'flop', 'bar', 'bar3D', 'prism3D', 'horizontalBar', 'helmetBar', 'line', 'progress', 'table', 'gauge', 'funnel', 'scatter', 'radar', 'img', 'imgborder', 'imgList', 'imgTabs', 'mixBar', , 'mixBarNew', 'rectangle', 'year', 'select'].concat(website.componentsList.filter(ele => ele.data === true).map(ele => ele.name)),
  barList: ['bar', 'horizontalBar', 'periodBar', 'helmetBar', 'mixBar', 'line', 'scatter', 'mixBarNew'],
  rightBarList: ['mixBarNew'],
  subYAxis: ['line'],
  titleList: ['bar', 'horizontalBar', 'periodBar', 'mixBarNew', 'radar', 'helmetBar', 'pie', 'pieCircle', 'pieCircleIndex', 'line', 'rectangle', 'scatter', 'funnel'],
  labelList: ['bar', 'horizontalBar', 'periodBar', 'mixBar', 'mixBarNew', 'helmetBar', 'line', 'pie', 'pieCircle', 'pieCircleIndex', 'rectangle', 'funnel', 'radar', 'scatter'],
  legendList: ['bar', 'horizontalBar', 'periodBar', 'mixBar', 'mixBarNew', 'helmetBar', 'pie', 'pieCircle', 'line', 'radar', 'funnel', 'gauge'],
  colorList: ['bar', 'horizontalBar', 'periodBar', 'mixBar', 'mixBarNew', 'helmetBar', 'pie', 'pieCircle', 'pieCircleIndex', 'line', 'gauge', 'funnel', 'scatter', 'radar', 'rectangle'],
  tipList: ['bar', 'horizontalBar', 'periodBar', 'mixBar', 'mixBarNew', 'helmetBar', 'pie', 'pieCircle', 'pieCircleIndex', 'line', 'rectangle', 'funnel', 'scatter', 'radar'],
  positionList: ['bar', 'horizontalBar', 'periodBar', 'helmetBar', 'mixBar', 'mixBarNew', 'line', 'pictorialbar', 'scatter'],
  labelFormatterList: ['bar', 'horizontalBar', 'periodBar', 'helmetBar', 'map', 'map3D', 'worldMap', 'newMap3D', 'line', 'pie', 'pieCircle', 'pieCircleIndex', 'gauge', 'funnel', 'scatter', 'radar', 'rectangle'],
  tabsTypeList: [{
    label: '选项卡',
    value: 'tabs',
  }, {
    label: '选择框',
    value: 'select',
  }],
  tabsComponentTypes: [
    {
      label: '本月本年',
      value: 'yearMonth',
    },
    {
      label: '近30天近12个月',
      value: '30Day12Month',
    },
  ],
  mapType: [{
    label: '原生',
    value: 0
  }],
  selectType: [{label: '工厂', value: 'factory'}, {label: '区域', value: 'area'}],
  target: [{label: '本窗口', value: '_self'}, {label: '新窗口', value: '_blank',}],
  swiperType: [{label: '普通', value: ''}, {label: '立体', value: 'card'}],
  swiperIndicator: [{label: '外部', value: 'indicator'}, {label: '不显示', value: 'none'}],
  format: [{label: '日期', value: 'yyyy-MM-dd'}, {label: '日期+时分', value: 'yyyy-MM-dd HH:mm'}, {
    label: '日期+时分秒',
    value: 'yyyy-MM-dd HH:mm:ss'
  }, {label: '日期(无年)', value: 'MM-dd'}, {label: '时分', value: 'HH:mm'}, {
    label: '时分秒',
    value: 'HH:mm:ss'
  }, {label: '星期', value: 'day'}],
  fontFamily: [{label: '宋体', value: 'SimSun'}, {label: '新宋体', value: 'NSimSun'}, {
    label: '黑体',
    value: 'SimHei'
  }, {label: '楷体', value: 'KaiTi_GB2312'}, {label: '微软雅黑', value: 'Microsoft YaHei'}, {
    label: '幼圆',
    value: 'YouYuan'
  }, {label: '华文细黑', value: 'STXihei'}, {label: '细明体', value: 'MingLiU'}, {
    label: '新细明体',
    value: 'PMingLiU'
  }, {label: '标题字体', value: 'TitleDarkFont'}, {label: '数字字体', value: 'DINProBold'}],
  animated: ['bounce', 'bounceIn', 'fadeInDownBig', 'fadeInLeftBig', 'fadeInRightBig', 'fadeInUpBig', 'flip', 'flipInX', 'flipInY'].map(ele => {
    return {label: ele, value: ele}
  }),
  // 注意！！！ 这里配置的是不显示相应的配置 指标 维度 分组等
  dimensions: ['table', 'indexCard', 'sheet', 'img'],
  // 这表示 饼图 不显示分组
  groups: ['pie', 'indexCard', 'radar', 'gauge', 'progress', 'wordcloud', 'img', 'text', 'textAreaModel'],
  metrics: ['table'],
  assistMetrics: ['gauge', 'progress', 'wordcloud', 'img', 'text'],
  totalMetrics: ['line', 'bar', 'table', 'indexCard', 'sheet', 'gauge', 'mixBarNew', 'horizontalBar', 'periodBar', 'radar', 'wordcloud', 'img', 'text', 'textAreaModel'],
  // 这里配的是显示列的组件，因为显示列的组件少，所以用包含，指标维度的多，用不包含配置
  columns: ['table', 'sheet'],
  rows: ['sheet'],
  reference: ['line', 'bar', 'mixBar', 'mixBarNew', 'horizontalBar', 'periodBar', 'radar'],
  SeparateIndicator: ['mixBarNew'],
  DoubleAxis: ['line'],

  // 自定义组件控制指标选项的特定配置
  customize: {
    dimensions: '维度',
    groups: '分组',
    metrics: '指标',
    assistMetrics: '辅助指标',
    totalMetrics: '总值指标'
  },
  // 时间组件配置项，年、月、日
  timeOption: [
    {label: '今年去年', value: 'year'},
    {label: '本月上月', value: 'month'},
    {label: '今日昨日', value: 'days'},
  ],
  toolTipOptions: [
    {label: '维度值', value: 'dimension'},
    {label: '指标名', value: 'metricName'},
    {label: '指标值', value: 'metricValue'},
    {label: '辅助指标名', value: 'assistMetricName'},
    {label: '辅助指标值', value: 'assistMetricValue'},
  ],
  fontWeightOptions: [
    {label: '细', value: 'lighter'},
    {label: '普通', value: 'normal'},
    {label: '粗体', value: 'bold'},
    {label: '加粗体', value: 'bolder'},
  ],
  legendTypeOptions: [
    {label: '默认图例', value: 'default'},
    {label: '区间图例', value: 'continuous'},
  ],
  legendPositionOptions: [
    {label: '上方居中', value: 'topCenter'},
    {label: '上方居左', value: 'topLeft'},
    {label: '上方居右', value: 'topRight'},
    {label: '下方居中', value: 'bottomCenter'},
    {label: '下方居左', value: 'bottomLeft'},
    {label: '下方居右', value: 'bottomRight'},
  ],
  legendIconOptions: [
    {label: '圆角矩形', value: 'roundRect'},
    {label: '矩形', value: 'rect'},
    {label: '圆形', value: 'circle'},
    {label: '三角形', value: 'triangle'},
    {label: '宝石', value: 'diamond'},
    {label: '别针', value: 'pin'},
    {label: '箭头', value: 'arrow'},
    {label: '无', value: 'none'},
  ],
}


function concat(prop, count, type, extend = [], defaults) {
  let list = [];
  for (let i = 1; i <= count; i++) {
    list.push({
      label: prop + i,
      value: `/img/${prop}/${prop}${i}.${extend.includes(i) ? defaults : type}`
    })
  }
  return list;
}